import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

import arrow_btn from "../../assets/images/icon/arrow-btn.svg";

import { Container, Row, Col } from "react-bootstrap";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { decryptDataFromArray } from "helpers/EncDec";
import api from "../../api";
import {
  checkPermissionStatus,
  generateMaskedPII,
  getCompanyTimezoneDateTime,
} from "helpers/utils";

const CandidateDetailsView = () => {
  const { appl_id } = useParams();
  const [msg, setMsg] = useState("");
  const [candidateDetails, setCandidateDetails] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get(
          `${process.env.REACT_APP_API_URL}/admin/candidate-details/fetch-details/${appl_id}`
        );

        let responseData = response.data;
        responseData = decryptDataFromArray(responseData);

        if (responseData?.status && responseData?.data?.length > 0) {
          setCandidateDetails(responseData?.data?.[0]);
        } else {
          setMsg("Invalid data format received from API");
        }
      } catch (error) {
        setMsg("Error fetching candidate details");
      }
    };

    fetchData();
  }, [appl_id]);

  useEffect(() => {
    if (Object.keys(candidateDetails).length !== 0) {
      handlePrintDetails();
      setTimeout(() => {
        window.close();
      }, 500);
    }
  }, [candidateDetails]);

  const handlePrintDetails = () => {
    const input = document.getElementById("pdf-content");

    html2canvas(input)
      .then(canvas => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF();
        const imgWidth = 210;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
        window.open(pdf.output("bloburl"));
      })
      .catch(error => {
        console.error("Error generating PDF:", error);
      });
  };

  return (
    <>
      <div className="inner-banner job-conslodiate">
        {/* <Container fluid>
          <div className="banner-content text-left  border-bottom py-2">
            <Col sm="6">
              <h5 className="text-uppercase heading-one">
                Candidate Consolidated View
              </h5>
            </Col>
          </div>
        </Container> */}
        <div className="joblist-container create-vacancy">
          <Row className="mb-3  depart-content align-items-center  py-2 pt-0">
            <Col lg="6" md="6">
              <Link to="/pending-list">
                <h5 className="text-uppercase heading-one pt-1">
                  {" "}
                  <img src={arrow_btn} alt="arrow_btn" /> Candidate Consolidated
                  View
                </h5>
              </Link>
            </Col>
            {/* <Col lg="6" md="6">
            <div className="single-filter-box btn-left d-flex justify-content-end align-items-center gap-2">
              <Button onClick={() => history.goBack()}>Back</Button>
            </div>
          </Col> */}
          </Row>
        </div>
      </div>

      <div className="outerTab-box-wrapper below-vacancy">
        <div className="col-md-12">
          <div className="cards-section cadidate-details cardshadow mt-2 pt-0">
            <div className="card-header">
              <h2 className="h4 mb-0">Personal Details</h2>
            </div>

            <div className="card-table-details tabel-application table-responsive ">
              <div className=" react-bootstrap-table">
                <table className="table table-bordered table-striped table-responsive">
                  <tbody>
                    <tr>
                      <td width={200}>
                        <span className="fw-bold">Name:</span>
                      </td>
                      <td>{candidateDetails.job_user?.name}</td>
                    </tr>
                    <tr>
                      <td width={200}>
                        <span className="fw-bold">Email Id:</span>
                      </td>
                      <td>{generateMaskedPII(candidateDetails.email_id)}</td>
                    </tr>
                    <tr>
                      <td width={200}>
                        <span className="fw-bold">Mobile No.:</span>
                      </td>
                      <td>
                        <a
                          href={
                            checkPermissionStatus(
                              "personal-id-info",
                              "view_unmasked"
                            )
                              ? `tel:${candidateDetails.mobile}`
                              : null
                          }
                        >
                          {generateMaskedPII(candidateDetails?.mobile, 2)}
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td width={200}>
                        <span className="fw-bold">Date of Birth:</span>
                      </td>
                      <td>
                        {moment(
                          getCompanyTimezoneDateTime(
                            candidateDetails.job_user?.dob
                          )
                        ).format("DD MMM YYYY")}
                      </td>
                    </tr>
                    <tr>
                      <td width={200}>
                        <span className="fw-bold">Age:</span>
                      </td>
                      {console.log(candidateDetails)}
                      <td>{candidateDetails.job_user?.age} Yrs</td>
                    </tr>
                    <tr>
                      <td width={200}>
                        <span className="fw-bold">Gender:</span>
                      </td>
                      <td>
                        {
                          candidateDetails?.job_user?.master_reference_table
                            ?.gender
                        }
                      </td>
                    </tr>
                    <tr>
                      <td width={200}>
                        <span className="fw-bold">Highest Qualification:</span>
                      </td>
                      <td>
                        {
                          candidateDetails?.master_reference_table
                            ?.highest_qualification
                        }
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-12 mt-4">
          <div className="cards-section cadidate-details cardshadow mt-2  pt-0">
            <div className="card-header">
              <h2 className="h4 mb-0">Application Details</h2>
            </div>

            <div className="card-table-details tabel-application table-responsive ">
              <div className=" react-bootstrap-table">
                <table className="table table-bordered table-striped table-responsive">
                  <tbody>
                    <tr>
                      <td width={200}>
                        <span className="fw-bold">Application Number:</span>
                      </td>
                      <td>
                        {candidateDetails.appl_id}/
                        {moment(
                          getCompanyTimezoneDateTime(
                            candidateDetails.apply_date
                          )
                        ).format("MMYYYY")}
                      </td>
                    </tr>
                    <tr>
                      <td width={200}>
                        <span className="fw-bold">Date:</span>
                      </td>
                      <td>
                        {moment(
                          getCompanyTimezoneDateTime(
                            candidateDetails.apply_date
                          )
                        ).format("DD MMM YYYY")}
                      </td>
                    </tr>
                    <tr>
                      <td width={200}>
                        <span className="fw-bold">Application Date:</span>
                      </td>
                      <td>
                        {moment(
                          getCompanyTimezoneDateTime(
                            candidateDetails.apply_date
                          )
                        ).format("DD MMM YYYY")}
                      </td>
                    </tr>
                    <tr>
                      <td width={200}>
                        <span className="fw-bold">Total Experience</span>
                      </td>
                      <td>
                        {candidateDetails.job_user?.total_experience} Years
                      </td>
                    </tr>
                    <tr>
                      <td width={200}>
                        <span className="fw-bold">City</span>
                      </td>
                      <td>{candidateDetails.master_city?.city}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CandidateDetailsView;
